var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloudUploadIcon = function SvgCloudUploadIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58,
    height: 53,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1D2329",
    fillRule: "evenodd",
    d: "M45.552 39.75H36.5v-1.5h9.052a10.65 10.65 0 0 0 3.968-20.527l-.398-.158-.06-.428a9.315 9.315 0 0 0-13.147-7.004l-.698.33-.307-.713a13.59 13.59 0 0 0-26.093 5.34q.008.92.135 1.83l.083.577-.548.218a10.65 10.65 0 0 0 3.96 20.535H21.5v1.5h-9.053A12.15 12.15 0 0 1 7.4 16.553a13 13 0 0 1-.083-1.5 15.09 15.09 0 0 1 28.658-6.57 10.6 10.6 0 0 1 3.877-.75 10.76 10.76 0 0 1 10.62 8.767 12.15 12.15 0 0 1-4.92 23.25",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#009FDB",
    fillRule: "evenodd",
    d: "m35.893 33-6.143-6.18V52.5h-1.5V26.82L22.108 33l-1.065-1.058L29 23.949l7.958 7.957z",
    clipRule: "evenodd"
  })));
};
export default SvgCloudUploadIcon;